import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="fixed top-0 bottom-0 left-0 right-0">
      <div className="w-full h-full flex flex-col items-center justify-center gap-2">
        <span className="text-5xl font-bold text-[#4CA6F8]">404</span>
        <span className="text-2xl">Page Not Found!</span>
        <p className="w-[600px] text-center">
          Sorry we can&apos;t seem to find the page you&apos;re looking for.
          There may be amisspelling in the URL entered, or the page you are
          looking for may no longer exist.
        </p>
        <Link
          to="/"
          className={`btn-lg bg-[#4CA6F8] text-white disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C] disabled:cursor-not-allowed`}
        >
          Go To Dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
